import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, Dialog } from '@knockrentals/knock-shared-web-v2';
import { ErrorDialog, LoadingOverlay } from '../../../knock-design-system';
import PropertyTransferTarget from './PropertyTransferTarget';
import useTransferProperty from './useTransferProperty';

const TransferPropertyDialog = ({
  isOpen,
  onClose,
  propertyName,
  propertyOwner,
  transferProperty,
}) => {
  const {
    companies,
    errorMessage,
    fetchCompanies,
    isLoading,
    setErrorMessage,
    setIsLoading,
    handleTransferProperty,
  } = useTransferProperty({ transferProperty });

  const handleDialogOnClose = (_e, reason) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  const handleErrorDialogOnClose = () => {
    setErrorMessage(null);
    onClose();
  };

  return (
    <ThemeProvider>
      <Dialog
        open={isOpen}
        onClose={handleDialogOnClose}
        title={`Transfer ${propertyName}`}
        withCloseIcon
      >
        <LoadingOverlay isInvisible isOpen={isLoading} zIndex={1301} />

        {isOpen && (
          <PropertyTransferTarget
            companies={companies}
            fetchCompanies={fetchCompanies}
            handleTransferProperty={handleTransferProperty}
            onClose={onClose}
            propertyOwner={propertyOwner}
            setErrorMessage={setErrorMessage}
            setIsLoading={setIsLoading}
          />
        )}
      </Dialog>

      <ErrorDialog
        closeDialog={handleErrorDialogOnClose}
        errorMessage={errorMessage}
        isOpen={Boolean(errorMessage)}
      />
    </ThemeProvider>
  );
};

TransferPropertyDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  propertyName: PropTypes.string,
  propertyOwner: PropTypes.number,
  transferProperty: PropTypes.func,
};

export default TransferPropertyDialog;
